<template>
	<main>
		<DadosAtendimento />
		<Modulo v-for="modulo in modulos" :key="modulo.idChecklistModulo" :modulo="modulo"/>
	</main>
</template>

<script>
import { defineComponent } from 'vue'
import DadosAtendimento from '@/common/dadosAtendimento/DadosAtendimento.vue'
import Modulo from '@/common/Modulo.vue'
import ModulosService from '@/services/ModulosService';

export default defineComponent({
	name: 'Modulos',
	components: {
		DadosAtendimento,
		Modulo
	},
	setup() {
		return ModulosService.setup()
	}
})
</script>